import { all, fork, call, put, takeLatest } from 'redux-saga/effects'

import { constants } from '../modules/itemsActions'
import * as api from '../api/item'

function* getAllItems(action) {
  try {
    const payload = yield call(api.getAllItems)
    yield put({ type: constants.GET_ALL_ITEMS.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_ALL_ITEMS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetAllItems() {
  yield takeLatest(constants.GET_ALL_ITEMS.ACTION, getAllItems)
}

function* getVendorItems(action) {
  try {
    const vendorItems = yield call(api.getVendorItems, action.vendorId)
    yield put({ type: constants.GET_VENDOR_ITEMS.SUCCESS, vendorItems })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_VENDOR_ITEMS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetVendorItems() {
  yield takeLatest(constants.GET_VENDOR_ITEMS.ACTION, getVendorItems)
}

function* sagaCreateNewItem(action) {
  try {
    action.item.created_by_id = action.userId
    action.item.updated_by_id = action.userId
    const payload = action.item
    const createdItem = yield call(api.createNewItem, payload)
    yield put({ type: constants.CREATE_NEW_ITEM.SUCCESS, payload })
    yield* uploadItemFiles({ ...action, itemId: createdItem.data.createdItemId[0] })
    yield call(getAllItems, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.CREATE_NEW_ITEM.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateNewItem() {
  yield takeLatest(constants.CREATE_NEW_ITEM.ACTION, sagaCreateNewItem)
}

function* sagaCreateNewItemVendor(action) {
  try {
    const payload = action.itemVendorPayload
    yield call(api.createNewItemVendor, payload)
    yield put({ type: constants.CREATE_NEW_ITEM_VENDOR.SUCCESS, payload })
    yield call(getItemVendors, { itemId: action.itemVendorPayload.item_id })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.CREATE_NEW_ITEM_VENDOR.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateNewItemVendor() {
  yield takeLatest(constants.CREATE_NEW_ITEM_VENDOR.ACTION, sagaCreateNewItemVendor)
}

function* sagaDeleteItemVendor(action) {
  try {
    const payload = action.itemVendorPayload
    yield call(api.deleteItemVendor, payload)
    yield put({ type: constants.DELETE_ITEM_VENDOR.SUCCESS, payload })
    yield call(getItemVendors, { itemId: action.itemVendorPayload.item_id })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_ITEM_VENDOR.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteItemVendor() {
  yield takeLatest(constants.DELETE_ITEM_VENDOR.ACTION, sagaDeleteItemVendor)
}

function* sagaUpdateSavedItem(action) {
  try {
    action.item.updated_by_id = action.userId
    const payload = {
      item: action.item,
      item_id: action.itemId
    }
    yield call(api.updateSavedItem, payload)
    yield put({ type: constants.UPDATE_SAVED_ITEM.SUCCESS, payload })

    yield* uploadItemFiles(action)

    yield call(getAllItems, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.UPDATE_SAVED_ITEM.FAILED,
      message: e.message || e
    })
  }
}

function* uploadItemFiles(action) {
  if (action.fileList) {
    const onlySelectedFiles = action.fileList
      .filter(file => file.originFileObj)
      .map(file => file.originFileObj)
    for (const file of onlySelectedFiles) {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('type', 'item')
      formData.append('created_by_id', action.userId)
      formData.append('updated_by_id', action.userId)
      formData.append('filename', file.name)
      formData.append('description', file.name)
      formData.append('itemId', action.itemId)
      formData.append('userId', action.userId)
      yield put({
        type: constants.SAVE_ITEM_IMAGE.ACTION,
        itemId: action.itemId,
        formData
      })
    }
  }
}

function* watchUpdateSavedItem() {
  yield takeLatest(constants.UPDATE_SAVED_ITEM.ACTION, sagaUpdateSavedItem)
}

function* sagaDeleteItem(action) {
  try {
    yield call(api.deleteItem, { itemId: action.itemId })
    yield put({ type: constants.DELETE_ITEM.SUCCESS })
    yield call(getAllItems, { jobId: action.jobId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_ITEM.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteItem() {
  yield takeLatest(constants.DELETE_ITEM.ACTION, sagaDeleteItem)
}

function* getItemImages(action) {
  try {
    const payload = yield call(api.getItemImages, action.itemId)
    yield put({ type: constants.GET_ITEM_IMAGES.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_ITEM_IMAGES.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetItemImages() {
  yield takeLatest(constants.GET_ITEM_IMAGES.ACTION, getItemImages)
}

function* getItemVendors(action) {
  try {
    const itemsVendors = yield call(api.getItemVendors, action.itemId)
    yield put({ type: constants.GET_ITEM_VENDORS.SUCCESS, itemsVendors })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_ITEM_VENDORS.FAILED,
      message: e.message || e
    })
  }
}

function* watchGetItemVendors() {
  yield takeLatest(constants.GET_ITEM_VENDORS.ACTION, getItemVendors)
}

function* saveItemImage(action) {
  try {
    const payload = {
      item_id: action.itemId,
      form_data: action.formData
    }
    yield call(api.saveItemImage, payload)
    yield put({ type: constants.SAVE_ITEM_IMAGE.SUCCESS, payload })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.SAVE_ITEM_IMAGE.FAILED,
      message: e.message || e
    })
  }
}

function* watchSaveItemImage() {
  yield takeLatest(constants.SAVE_ITEM_IMAGE.ACTION, saveItemImage)
}

function* deleteItemImage(action) {
  try {
    const payload = {
      image_id: action.imageId,
      item_id: action.itemId
    }

    yield call(api.deleteItemImage, payload)
    yield put({ type: constants.DELETE_ITEM_IMAGE.SUCCESS, payload })
    yield call(getItemImages, { itemId: action.itemId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_ITEM_IMAGE.FAILED,
      message: e.message || e
    })
  }
}

function* watchDeleteItemImage() {
  yield takeLatest(constants.DELETE_ITEM_IMAGE.ACTION, deleteItemImage)
}

// notes
function* fetchItemNote(action) {
  try {
    const itemNotes = yield call(api.fetchItemNote, { itemId: action.itemId })
    yield put({ type: constants.GET_ITEM_NOTE.SUCCESS, itemNotes })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.GET_ITEM_NOTE.FAILED,
      message: e.message || e
    })
  }
}

function* watchFetchItemNote() {
  yield takeLatest(constants.GET_ITEM_NOTE.ACTION, fetchItemNote)
}

function* createItemNote(action) {
  try {
    const payload = {
      content: action.content,
      itemId: action.itemId
    }
    yield call(api.createItemNote, payload)
    yield put({ type: constants.CREATE_ITEM_NOTE.SUCCESS, payload })
    yield call(fetchItemNote, { itemId: action.itemId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.CREATE_ITEM_NOTE.FAILED,
      message: e.message || e
    })
  }
}

function* watchCreateItemNote() {
  yield takeLatest(constants.CREATE_ITEM_NOTE.ACTION, createItemNote)
}

function* editItemNote(action) {
  try {
    const payload = {
      content: action.content,
      noteId: action.noteId
    }
    yield call(api.editItemNote, payload)
    yield put({ type: constants.EDIT_ITEM_NOTE.SUCCESS, payload })
    yield call(fetchItemNote, { itemId: action.itemId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.EDIT_ITEM_NOTE.FAILED,
      message: e.message || e
    })
  }
}

function* watchEditItemNote() {
  yield takeLatest(constants.EDIT_ITEM_NOTE.ACTION, editItemNote)
}

function* deleteItemNote(action) {
  try {
    const payload = {
      noteId: action.noteId
    }
    yield call(api.deleteItemNote, payload)
    yield put({ type: constants.DELETE_ITEM_NOTE.SUCCESS, payload })
    yield call(fetchItemNote, { itemId: action.itemId })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.DELETE_ITEM_NOTE.FAILED,
      message: e.message || e
    })
  }
}

function* printItems(action) {
  try {
    yield call(api.printItems, action.queryString)
    yield put({ type: constants.PRINT_ITEMS.SUCCESS })
  } catch (e) {
    console.log(e)
    Raven.captureException(e)
    yield put({
      type: constants.PRINT_ITEMS.FAILED,
      message: e.message || e
    })
  }
}

function* watchPrintItems() {
  yield takeLatest(constants.PRINT_ITEMS.ACTION, printItems)
}

function* watchDeleteItemNote() {
  yield takeLatest(constants.DELETE_ITEM_NOTE.ACTION, deleteItemNote)
}

export function* rootSaga() {
  yield all([
    fork(watchGetAllItems),
    fork(watchCreateNewItem),
    fork(watchUpdateSavedItem),
    fork(watchDeleteItem),
    fork(watchGetItemImages),
    fork(watchSaveItemImage),
    fork(watchDeleteItemImage),

    fork(watchGetItemVendors),
    fork(watchGetVendorItems),

    fork(watchCreateNewItemVendor),
    fork(watchDeleteItemVendor),

    fork(watchPrintItems),

    //notes
    fork(watchFetchItemNote),
    fork(watchCreateItemNote),
    fork(watchEditItemNote),
    fork(watchDeleteItemNote)
  ])
}



// WEBPACK FOOTER //
// ./src/redux/sagas/itemsSaga.js